import { QueryClient } from '@tanstack/react-query';
import * as activityTrackerApi from '@company/services/activityTracker/api';
import { ActivityDetail } from '@th-types/daily-activity.type';
import { IJobShiftsResult } from '@th-types/jobs.type';
import {
  submitHoursRefreshQueryData,
  markPaidSuccessRefreshQueryData,
  approveTimeSheetRefreshQueryData,
  cancelShiftSuccessRefreshQueryData,
} from './JobUtils';

export const onSubmitHoursSuccess = (
  activity: ActivityDetail,
  jobShiftsListResult: IJobShiftsResult | undefined,
  queryJobShiftsList: string[],
  queryClient: QueryClient
) => {
  if (jobShiftsListResult) {
    submitHoursRefreshQueryData(
      activity,
      queryJobShiftsList,
      queryClient,
      jobShiftsListResult
    );
  }
};

// Called when the user clicks on Mark Paid button from shift review modal
export const onMarkPaidSuccess = (
  activity: ActivityDetail,
  jobShiftsListResult: IJobShiftsResult | undefined,
  queryJobShiftsList: string[],
  queryClient: QueryClient
) => {
  if (jobShiftsListResult) {
    markPaidSuccessRefreshQueryData(
      activity,
      queryJobShiftsList,
      queryClient,
      jobShiftsListResult
    );
  }
};

// Called when the user clicks on Cancel Shift button from shift review modal
export const onCancelShiftSuccess = (
  activity: ActivityDetail,
  jobShiftsListResult: IJobShiftsResult | undefined,
  queryJobShiftsList: string[],
  queryClient: QueryClient
) => {
  if (jobShiftsListResult) {
    cancelShiftSuccessRefreshQueryData(
      activity,
      queryJobShiftsList,
      queryClient,
      jobShiftsListResult
    );
  }
};

export const approveTimeSheet = async (
  activityDetail: ActivityDetail,
  setIsLoadingAction: (isLoading: boolean) => void,
  showSuccessAlert: (message: string) => void,
  showWarningAlert: (message: string) => void,
  refetch?: () => void
) => {
  try {
    setIsLoadingAction(true);
    if (activityDetail.timeSheet) {
      const result = await activityTrackerApi.approveTimeSheet(
        activityDetail.shiftPosition.jobId,
        activityDetail.timeSheet.id
      );
      if (result.success) {
        showSuccessAlert(result.message);
        if (refetch) {
          await refetch();
        }
      } else {
        showWarningAlert(result.errorMessage);
      }
    }
  } catch (err) {
    console.log(`Occurred an error trying to cancel shift`, err);
  } finally {
    setIsLoadingAction(false);
  }
};

export const onApproveTimeSheetSuccess = (
  activity: ActivityDetail,
  jobShiftsListResult: IJobShiftsResult | undefined,
  queryJobShiftsList: string[],
  queryClient: QueryClient,
  approvedBy: string
) => {
  if (jobShiftsListResult) {
    approveTimeSheetRefreshQueryData(
      approvedBy,
      activity,
      queryJobShiftsList,
      queryClient,
      jobShiftsListResult
    );
  }
};
